"use strict";
const reduce = require('lodash/reduce');
const values = require('lodash/values');
const { DYNAMIC_ATTRIBUTES_REGEX, ENTITY_TYPES } = require('./consts');
const findDynamicUrlAttributes = (url) => {
    const matches = url.match(DYNAMIC_ATTRIBUTES_REGEX) || [];
    const dynamicAttributes = matches.map((attr) => attr.slice(1, attr.length - 1));
    return reduce(dynamicAttributes, (accumulator, curr) => {
        const [type, attributeId] = curr.split('.');
        if (!attributeId || !values(ENTITY_TYPES).includes(type)) {
            return accumulator;
        }
        const currentInType = accumulator[type];
        return { ...accumulator, [type]: currentInType ? [...currentInType, attributeId] : [attributeId] };
    }, {});
};
module.exports = {
    findDynamicUrlAttributes,
};
//# sourceMappingURL=utils.js.map